import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { catchError, map, Observable, throwError } from 'rxjs';
import { AppError } from '../models/app-error.model';
import { extractErrorMessage } from '@app/core/utils/extract-error-message';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      map((event) => {
        if (event instanceof HttpResponse) {
          const body: any = event.body;
          if (body && body.process === false) {
            throw {
              process: false,
              message: extractErrorMessage(body.message),
              statusCode: event.status,
              identifier: body.identifier
            };
          }
        }
        return event;
      }),
      catchError((error: unknown) => {

        console.log(error);
        // 🔴 Error real HTTP
        if (error instanceof HttpErrorResponse) {
          const normalizedError: AppError = {
            process: false,
            message: error.error?.message || error.message,
            statusCode: error.status,
            identifier: error.error?.identifier
          };

          return throwError(() => normalizedError);
        }

        return throwError(() => error);
      })
    );
  }
}
